export const REENTRY_PLANS_LIST_PATH = '/reentry-plans';

export const CASE_PLAN_SECTION_SKELETON_COUNT = 3;

/** Index of the section that exposes the editable description field */
export const CASE_PLAN_EDITABLE_SECTION_INDEX = 0;

export const buildReentryPlanDetailsPath = (casePlanId) =>
  `${REENTRY_PLANS_LIST_PATH}/details/${casePlanId}`;

export const REENTRY_PLANNING_TABS = {
  ALL_PLANS: 'All Plans',
};

export const CASE_PLAN_EDIT_PLAN_PERMISSION = 'case_plan_edit_plan';
export const CASE_PLAN_MANAGE_ALL_PLANS_PERMISSION = 'case_plan_manage_all_plans';
export const CASE_PLAN_PREVIEW_RELEASE_PERMISSION = 'case_plan_preview_release_access';

export const CASE_PLAN_ACCESS_PERMISSIONS = [
  CASE_PLAN_EDIT_PLAN_PERMISSION,
  CASE_PLAN_MANAGE_ALL_PLANS_PERMISSION,
  CASE_PLAN_PREVIEW_RELEASE_PERMISSION,
];

export const REENTRY_PLAN_FEATURE = 'reentry_plan';

export const REENTRY_PLANS_DEFAULT_PAGE_SIZE = 25;

export const REENTRY_PLANS_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const VIEW_PLAN_LINK_COLOR = 'var(--tonal-palette-cerulean-main-20, #0078A2)';

/** Pendo tracking id for the Create New Plan action on the All Plans table */
export const REENTRY_CREATE_NEW_PLAN_BUTTON_ID = 'create-new-plan-button';

/** Modal detail keys for Honest Jobs community resources from reentry plan `resources` groups. */
export const HONEST_JOBS_RESOURCE_DETAIL_FIELD_KEYS = [
  'Eligibility',
  'Availability',
  'Description',
  'Languages',
  'Cost',
  'Next Steps',
  'Website',
  'Facebook',
  'Coverage Area',
  'Required',
  'Last Reviewed',
];

/** Modal detail keys for Honest Jobs job listings from reentry plan `jobs` groups. */
export const HONEST_JOBS_JOB_DETAIL_FIELD_KEYS = [
  'Pay Rate',
  'Frequency',
  'Education Level',
  'Description',
];
